// import React from "react";
// import PropTypes from "prop-types";
// import EquipmentListDetailEstimate from "../../list/EquipmentListDetailEstimate";

// function ValuationTab({ evalItem, evaluation, onSaving }) {
//   return (
//     <EquipmentListDetailEstimate
//       key={`estimates-${evalItem?.item_id}`}
//       evalItem={evalItem}
//       evaluation={evaluation}
//       showSaved
//       onRefresh={onSaving}
//     />
//   );
// }

// ValuationTab.propTypes = {
//   evalItem: PropTypes.object.isRequired,
//   evaluation: PropTypes.object,
//   onSaving: PropTypes.func,
// };

// export default ValuationTab;


import React from "react";
import PropTypes from "prop-types";
import EquipmentListDetailEstimate from "../../list/EquipmentListDetailEstimate";

function ValuationTab({ evalItem, evaluation, onSaving }) {
  // Don't render the component if evaluation is null/undefined
  if (!evaluation) {
    return (
      <div style={{ padding: '16px', textAlign: 'center' }}>
        <p>No evaluation data available</p>
      </div>
    );
  }

  return (
    <EquipmentListDetailEstimate
      key={`estimates-${evalItem?.item_id}`}
      evalItem={evalItem}
      evaluation={evaluation}
      showSaved
      onRefresh={onSaving}
    />
  );
}

ValuationTab.propTypes = {
  evalItem: PropTypes.object.isRequired,
  evaluation: PropTypes.object.isRequired, // Mark as required to match the child component
  onSaving: PropTypes.func,
};

export default ValuationTab;